import { Organization } from "./organization.model.ts";
import {Person} from "./person.model.ts";

export class Employee {
  id: number;
  person: Person;
  organization: Organization;
  constructor() {
    this.id = -1;
    this.person = new Person();
    this.organization = new Organization();
  }
}


